import { render, staticRenderFns } from "./approvaled.vue?vue&type=template&id=26d37c92&scoped=true&"
import script from "./approvaled.vue?vue&type=script&lang=js&"
export * from "./approvaled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d37c92",
  null
  
)

export default component.exports